import _ from 'lodash';
import { useUser } from '@lore/auth';
import useGetCount from '@/pages/explore/useGetCount';

// Partners
import relatedPartners from '@/pages/partners-filtered/related/useQuery';
import sitesPartners from '@/pages/partners-filtered/sites/useQuery';
import starredPartners from '@/pages/partners-filtered/starred/useQuery';
import incompletePartners from '@/pages/partners-filtered/incomplete/useQuery';
import newPartners from '@/pages/partners-filtered/new/useQuery';
import sleepingPartners from '@/pages/partners-filtered/sleeping/useQuery';
import inactivePartners from '@/pages/partners-filtered/inactive/useQuery';

export default function getNavigationLinks() {
  const currentUser = useUser();
  const showAll = !currentUser.lowerNetworkBarriers

  return _.compact([
    showAll && { id: 'all', name: 'All', href: `/partners` },
    { id: 'connected-to-your-sites', name: 'Connected to your sites', href: `/partners/related`, count: useGetCount(relatedPartners) },
    { id: 'all-near-me', name: 'All Near Me', href: `/partners/sites`, count: useGetCount(sitesPartners) },
    currentUser.data.isSuperuser ?
      { id: 'engagement', name: '[Engagement]', href: `/partners/engagement` } :
      null,
    { id: 'starred', name: 'Starred', href: `/partners/starred`, count: useGetCount(starredPartners) },
    { id: 'new', name: 'New', href: `/partners/new`, count: useGetCount(newPartners), highlight: true },
    { id: 'sleeping', name: 'Sleeping', href: `/partners/sleeping`, count: useGetCount(sleepingPartners) },
    { id: 'inactive', name: 'Inactive', href: `/partners/inactive`, count: useGetCount(inactivePartners) },
    { id: 'incomplete-profile', name: 'Incomplete Profile', href: `/partners/incomplete`, count: useGetCount(incompletePartners) },
  ]);
}
